module.exports = __webpack_public_path__ + "img/4@3x.00631221.png";